<template>
  <div>
    <table
      v-if="!loading && data.length"
      class="table"
    >
      <thead>
        <tr>
          <td
            v-for="(query, i1) in dataTable.thead"
            :key="i1"
          >
            {{ query }}
          </td>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, i2) in dataTable.tbody"
          :key="i2"
        >
          <td
            v-for="(site, i3) in row"
            :key="i3"
          >
            {{ site.text }}
          </td>
        </tr>
      </tbody>
    </table>
    <no-data v-if="!loading && !data.length" />
  </div>
</template>

<script>
import NoData from '../../../../../../../resources/js/components/NoData.vue'
export default {
  name: 'AnalyticsYandexTop10',
  components: { NoData },
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dataTable () { // трансформация входных данных
      const thead = []
      const tbody = []
      const countRows = 10
      for (const [iCol, queryRow] of this.data.entries()) {
        for (const [query, queryData] of Object.entries(queryRow)) {
          thead[iCol] = query
          // тело таблицы
          for (let iRow = 0; iRow < countRows; iRow++) {
            if (iCol === 0) {
              tbody[iRow] = []
            }
            try {
              tbody[iRow][iCol] = { text: queryData[iRow].site, color: queryData[iRow].hostRating }
            } catch (e) {
              tbody[iRow][iCol] = { text: null, color: null }
            }
          }
          break
        }
      }

      return { thead: thead, tbody: tbody }
    }
  }
}
</script>

<style scoped lang="scss">
  table thead tr td {
    font-weight: bold;
  }
</style>
